

const galleryThumbs = new Swiper(".gallery-thumbs", {
  breakpoints: {
    319: {
      spaceBetween: 20,
      slidesPerView: 1.7,
      // direction: "horizontal",
      watchSlidesProgress: true,
      watchOverflow: true,
      pagination: {
        el: ".connect-pagination.swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    },
    525: {
      slidesPerView: 2,
      spaceBetween: 20,
      direction: "horizontal",
      pagination: {
        el: ".connect-pagination.swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 20,
      direction: "horizontal",
      pagination: {
        el: ".connect-pagination.swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    },
    1201: {
      slidesPerView: 3,
      direction: "vertical",
      touchRatio: 0,
    },
  },
});
const galleryTop = new Swiper(".gallery-top", {
  direction: "horizontal",
  spaceBetween: 10,
  effect: "fade",
  thumbs: {
    swiper: galleryThumbs,
  },
});

const allGridItems = document.querySelectorAll(".article-grid-item");
const allPaginationItems = document.querySelectorAll(
  ".article-pagination__item"
);
if (window.innerWidth <= 991 && allGridItems) {
  const newArr = [...allGridItems];
  newArr.slice(6, 15).forEach((item) => (item.style.display = "none"));
}

if (window.innerWidth <= 991 && allPaginationItems) {
  const newArr = [...allPaginationItems];
  newArr.slice(4, 14).forEach((item) => (item.style.display = "none"));
}

const themeSlider = document.querySelector(".themes-slider");
if (themeSlider && window.innerWidth <= 1200) {
  const themeSwiper = new Swiper(themeSlider, {
    navigation: {
      nextEl: ".themes-button.swiper-button-next",
      prevEl: ".themes-button.swiper-button-prev",
    },
    pagination: {
      el: ".themes-pagination.swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      370: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      767: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      991: {
        slidesPerView: 2.5,
        spaceBetween: 40,
      },
    },
  });
}

const reviewsSlider = new Swiper(".reviews-slider", {
  slidesPerView: 1,
  spaceBetween: 40,
  freeMode: {
    enabled: true,
    sticky: true,
  },
  breakpoints: {
    700: {
      pagination: {
        el: ".reviews-pagination.swiper-pagination",
        type: "bullets",
        clickable: true,
      },
    },
  },
  navigation: {
    nextEl: ".reviews-button.swiper-button-next",
    prevEl: ".reviews-button.swiper-button-prev",
  },
});
const blogDown = document.querySelector(".blog-down");
blogDown
  ? blogDown.addEventListener("click", (e) => {
      e.preventDefault();
      blogDown.scrollIntoView({
        behavior: "smooth",
      });
    })
  : false;

const videos = [...document.querySelectorAll(".archive-video")];
const buttonsPlay = [...document.querySelectorAll(".video-play")];
if (videos && buttonsPlay) {
  for (let i = 0; i < videos.length; i++) {
    buttonsPlay[i].addEventListener("click", function () {
      this.style.display = "none";
      videos[i].setAttribute("controls", "controls");
      videos[i].play();
    });
  }
}

const videoSlider = document.querySelector(".archive-video-slider");
if (videoSlider && window.innerWidth <= 1200) {
  const videoSwiper = new Swiper(videoSlider, {
    navigation: {
      nextEl: ".archive-video-slider-button.swiper-button-next",
      prevEl: ".archive-video-slider-button.swiper-button-prev",
    },
    pagination: {
      el: ".archive-video-pagination.swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      370: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      525: {
        slidesPerView: 1.5,
        spaceBetween: 40,
      },
      767: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      991: {
        slidesPerView: 2.5,
        spaceBetween: 40,
      },
    },
  });
}

const smiSlider = document.querySelector(".smi-slider");
if (smiSlider && window.innerWidth <= 1200) {
  const smiSwiper = new Swiper(smiSlider, {
    navigation: {
      nextEl: ".smi-slider-button.swiper-button-next",
      prevEl: ".smi-slider-button.swiper-button-prev",
    },
    pagination: {
      el: ".smi-pagination.swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      370: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      525: {
        slidesPerView: 1.5,
        spaceBetween: 40,
      },
      767: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      991: {
        slidesPerView: 2.5,
        spaceBetween: 40,
      },
    },
  });
}

const tourSlider = document.querySelector(".tour-slider-inner");
if (tourSlider) {
  const tourSwiper = new Swiper(tourSlider, {
    slidesPerView: 1,
    spaceBetween: 30,
    navigation: {
      nextEl: ".tour-slider-swiper-button.swiper-button-next",
      prevEl: ".tour-slider-swiper-button.swiper-button-prev",
    },
    pagination: {
      el: ".tour-slider-pagination.swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });
}

const programSlider = document.querySelector(".program-slider");
if (programSlider) {
  const programSwiper = new Swiper(programSlider, {
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: ".program-pagination.swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    navigation: {
      nextEl: ".program-slider-button.swiper-button-next",
      prevEl: ".program-slider-button.swiper-button-prev",
    },
  });
}

const acc = document.querySelectorAll(".accordion");

for (let i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.classList.toggle("active");

    /* Toggle between hiding and showing the active panel */
    const panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
    }
  });
}

const liveSlider = document.querySelector(".live-slider.swiper");
if (liveSlider && window.innerWidth <= 767) {
  const liveSwiper = new Swiper(liveSlider, {
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: ".live-slider-pagination.swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });
}

const certificateSlider = document.querySelector(".certificate-slider");
if (certificateSlider) {
  const certificateSwiper = new Swiper(certificateSlider, {
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: ".certificate-slider-pagination.swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    navigation: {
      nextEl: ".certificate-slider-button.swiper-button-next",
      prevEl: ".certificate-slider-button.swiper-button-prev",
    },
  });
}

// const posterWrapper = document.querySelector(".poster-wrapper");
// const posterButton = document.querySelector(".video-play");
// const videoFrame = document.querySelector(".poster-wrapper__in");
// if (videoPosterButton) {

// 	const generateUrl = (id) => {
// 		let query = "?rel=0&showinfo=0&autoplay=1";
// 		return "https://www.youtube.com/embed/" + id + query;
// 	};

// 	const createIframe = (id) => {
// 		const iframe = document.createElement("iframe");

// 		iframe.setAttribute("allowfullscreen", "");
// 		iframe.setAttribute("allow", "autoplay; encrypted-media");

// 		iframe.setAttribute('src', generateUrl(id));

// 		return iframe;
// 	};

// 	const videoHref = artVideoFrame.dataset.video;

// 	const deletedLength = "https://youtu.be/".length;
// 	const videoId = videoHref.substring(deletedLength, videoHref.length);

// 	videoPosterButton.addEventListener("click", () => {
// 		const iframe = createIframe(videoId);

// 		artVideoFrame.appendChild(iframe);
//     videoPosterButton.style.pointerEvents = 'none';
// 		setTimeout(() => {
// 			videoPosterWrapper.setAttribute("data-show", "false");
// 		}, 1000);
// 	});
// }

const inSliders = document.querySelectorAll(".panel__slider");
if (inSliders) {
  inSliders.forEach((item) => {
    new Swiper(item, {
      breakpoints: {
        319: {
          slidesPerView: 2,
          spaceBetween: 19,
          cssMode: true,
        },
        525: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        767: {
          slidesPerView: 1.5,
          spaceBetween: 19,
        },

        1200: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
      },
    });
  });
}

const commandSlider = document.querySelector(".command-slider");
if (commandSlider) {
  const swiper1 = new Swiper(".command-thumbs", {
    spaceBetween: 40,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,

    breakpoints: {
      1200: {
        spaceBetween: 40,
        slidesPerView: 6,
      },
      991: {
        spaceBetween: 20,
        slidesPerView: 5.5,
      },
      767: {
        slidesPerView: 4,
      },
      525: {
        slidesPerView: 3.5,
      },
      374: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      319: {
        slidesPerView: 1.2,
        spaceBetween: 50,
      },
    },
  });
  const swiper2 = new Swiper(commandSlider, {
    spaceBetween: 10,
    loop: true,
    autoHeight: true,
    navigation: {
      nextEl: ".command-swiper-button.swiper-button-next",
      prevEl: ".command-swiper-button.swiper-button-prev",
    },
    thumbs: {
      swiper: swiper1,
    },
    pagination: {
      el: ".command-slider-pagination.swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });
}

const directionSlider = document.querySelector(".direction-slider");
if (commandSlider) {
  const swiper1 = new Swiper(".direction-thumbs", {
    spaceBetween: 40,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      1200: {
        spaceBetween: 40,
        slidesPerView: 4,
      },
      991: {
        spaceBetween: 40,
        slidesPerView: 4,
      },
      767: {
        slidesPerView: 3.5,
        spaceBetween: 20,
      },
      525: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      325: {
        slidesPerView: 1.7,
        spaceBetween: 20,
      },
    },
  });
  const swiper2 = new Swiper(directionSlider, {
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".direction-slider-button.swiper-button-next",
      prevEl: ".direction-slider-button.swiper-button-prev",
    },
    thumbs: {
      swiper: swiper1,
    },
    pagination: {
      el: ".direction-slider-pagination.swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });
}

const MODAL = document.querySelector(".modal");
const MODAL_CLOSE = [...document.querySelectorAll(".modal-form__close")];
const ORDER_BUTTON = document.querySelector(".participation-button--order");
const CONSULTATION_BUTTON = document.querySelector(
  ".participation-button--consultation"
);

if (ORDER_BUTTON || CONSULTATION_BUTTON) {
  ORDER_BUTTON.addEventListener("click", () => {
    MODAL.classList.add("modal--show");
    MODAL.querySelector(".modal-form--reserve").classList.add(
      "modal-form--active"
    );
    body.style.overflow = "hidden";
  });
  CONSULTATION_BUTTON.addEventListener("click", () => {
    MODAL.classList.add("modal--show");
    MODAL.querySelector(".modal-form--consultation").classList.add(
      "modal-form--active"
    );
    body.style.overflow = "hidden";
  });
  MODAL_CLOSE.forEach((close) => {
    close.addEventListener("click", (e) => {
      e.preventDefault();
      MODAL.classList.remove("modal--show");
      MODAL.querySelector(".modal-form--reserve").classList.remove(
        "modal-form--active"
      );
      MODAL.querySelector(".modal-form--consultation").classList.remove(
        "modal-form--active"
      );
      body.style.overflow = "visible";
    });
  });
}

function tabFunc(
  tabs,
  tabsContainer,
  tabsContent,
  activeTabClass,
  activeContentClass
) {
  const tabsItem = document.querySelectorAll(`.${tabs}`);
  const tabContainer = document.querySelector(`.${tabsContainer}`);
  const tabsCont = document.querySelectorAll(`.${tabsContent}`);

  tabContainer.addEventListener("click", function (e) {
    const target = e.target.closest(`.${tabs}`);

    const activeHalf = activeContentClass.split("--");

    if (!target) return;

    tabsItem.forEach((tab) => tab.classList.remove(activeTabClass));
    target.classList.add(activeTabClass);

    tabsCont.forEach((content) => content.classList.remove(activeContentClass));
    document
      .querySelector(`.${activeHalf[0]}--${target.dataset.tab}`)
      .classList.add(activeContentClass);
  });
}

const NEAR_SECTION = document.querySelector(".near");
if (NEAR_SECTION) {
  tabFunc(
    "near-tab",
    "near-tabs",
    "near-content",
    "near-tab--active",
    "near-content--active"
  );
}

const OFFERING_SHOW_MORE = document.querySelector(".offering-show-more");
if (OFFERING_SHOW_MORE) {
  OFFERING_SHOW_MORE.addEventListener("click", (e) => {
    e.preventDefault();
    document
      .querySelectorAll(".offering-item")
      .forEach((i) => i.classList.remove("offering-item--hide"));
    OFFERING_SHOW_MORE.style.display = "none";
  });
}


